import { render, staticRenderFns } from "./CouponProfile.vue?vue&type=template&id=8f514c2c"
import script from "./CouponProfile.vue?vue&type=script&lang=js"
export * from "./CouponProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports